import { jsonFetch } from "@/lib/helpers";
import { getHostifyListingsUrl } from "./api-url.constants";

export interface HostifyListing {
  id: number;
  nickname: string;
  name: string;
  country: string;
  city: string;
  street: string;
}

export const getHostifyListings = async (userId?: string): Promise<HostifyListing[]> => {
  const { data } = await jsonFetch<{ data: HostifyListing[] }>(getHostifyListingsUrl(userId));
  return data;
};
